import React from "react";
import { Carousel, Col, notification, Row } from "antd";
import BannersApi from "../../api-services/banners-api.service";
import SlickButtonFix from "../../components/shared/SlickButtonFix";
import { Banner } from "../../interfaces/banner.interface";
import SearchBarWidget from "../../widgets/SearchBarWidget";
import LocationTabs from "../../components/shared/LocationTabs";
import Testimonials from "./Testimonials";
import Banners from "../../components/shared/Banners";
import LocationsApi from "../../api-services/locations-api.service";

export default class Homepage extends React.Component {
  bannersApi = new BannersApi;
  locationsApi = new LocationsApi;

  state = {
    banners: [],
    locations: []
  }


  componentDidMount() {
    Promise.all([
        this.bannersApi.getBanners(),
        this.locationsApi.getCountries(),
      ]).then(([banners, locationsData]) => {
        this.setState({banners, locations: locationsData.locations})
      }).catch(error => {
        notification.error({ message: 'Something went wrong.'});
      });
  }

  render(){
    const { banners } = this.state;

    return (
      <div id="homepage">
    
      <SearchBarWidget datePlaceholder="Select"/>
  
      <div id="homepage_banner"> 
        <Banners 
          banners={banners} 
          previousArrowIcon={<img src="/iceholidays-assets/images/banner_arrow.png"/>} 
          nextArrowIcon={<img src="/iceholidays-assets/images/banner_arrow.png" className="flip"/>}/>
      </div>
      
      <LocationTabs locations={this.state.locations} header={<h1>Explore Popular Destination</h1>}/>

      <div id="testimonials-section">
        <Testimonials/>
      </div>
  
      <div id="about-signature-tours" style={{background: "url('/iceholidays-assets/images/about_st_bg.png') no-repeat 70% 7%, linear-gradient(65.77deg, rgba(170, 133, 62, 0.5) 33.44%, rgba(249, 225, 151, 0.5) 67.37%)"}}>
        <div>
          <h1>ABOUT SIGNATURE TOURS</h1>
          <p>
            From charming accommodations to curated cultural encounters, every  aspect is thoughtfully crafted to elevate your travel experience. At The  Signature Tours, we believe in the S-Tour’s philosophy —where every  moment is a signature memory.
          </p>
          <picture>
            <source media="(min-width: 600px)" srcSet="/iceholidays-assets/images/about-us_logo.png" />
            <source media="(max-width: 599px)" srcSet="/iceholidays-assets/images/about-us_logo_mobile.png" />
            <img src="/iceholidays-assets/images/about-us_logo.png" alt="About Signature Tours Logo Line"/>
          </picture>
          <div id="about-st-feature">
            <Row gutter={[20, 20]} align="middle">
              <Col flex="1 0 50%" className="column">
                <p>Every  experience is meticulously designed to create memories that last a  lifetime. Our journeys go beyond the ordinary, offering experiences that  are as unique as you are.</p>
              </Col>
              <Col flex="1 0 50%" className="column">
                <div id="feature">
                  <img src="/iceholidays-assets/images/feature.jpg"/>
                  <div id="st-brand">
                    <span>Signature Tours</span>
                    <img src="/iceholidays-assets/images/logomark.png" id="st-logo"/>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
    )
  }
}
